export const gridReportFields = {
  NAME: 'reportName',
  ID: 'id',
};
